<template>
  <Container
    class="mt-20 mb-30 items-center md:mt-25 xl:mt-30! xl:mb-42.5 2xl:mt-35! 2xl:mb-42.5!"
  >
    <div
      class="flex w-full max-w-91.25 flex-col gap-5 md:max-w-130 md:gap-7.5 lg:max-w-133 xl:max-w-165 xl:gap-10 2xl:gap-11.5"
    >
      <SectionTitle
        :title="sectionData.title"
        :link="sectionData.url"
        :target="sectionData.target"
      />

      <div class="flex flex-col">
        <NoticeRow
          v-for="notice in notificationData"
          :key="notice.id"
          :notice="notice"
          class="first:border-t"
        />
      </div>
    </div>
  </Container>
</template>

<script setup lang="ts">
import type { HomepageSection, Notice } from '~/types'

interface Props {
  sectionData: HomepageSection<Notice>
}
const props = defineProps<Props>()

const notificationData = computed(() => props.sectionData?.items)
</script>
